import React, { useContext } from 'react'
import { QuranAudios } from '../data/Audios'
import { FontAwesome } from '../data/FontAwesome';
import { AppContext } from '../AppContext';

export default function Recitations() {

    const { reciteQuranAudio, showMsg, t, isRtl } = useContext(AppContext)
    const reciterName = t('recitations.reciterMaher')
    const getSurahName = (q) => t('recitations.surahs.' + q.id) || q.name

    return (
        <div>

            <h5>{t('recitations.title')}</h5>
            {QuranAudios.map((q) => (<button key={'Q' + q.id} type='button'
                className={'btn btn-sm btn-primary my-2 col-12 ' + (isRtl ? 'text-end' : 'text-start')} onClick={() => {
                    reciteQuranAudio(q.id);
                    showMsg(t('recitations.startMsg').replace('{reciter}', reciterName));
                    document.activeElement.blur();
                }}>
                <div title={reciterName} className={'d-flex justify-content-between p-1 gap-3 ' + (isRtl ? 'flex-row-reverse' : 'flex-row')}>
                    <div className='pt-1'>{FontAwesome.Play}</div>
                    <div className='flex-grow-1'>
                        <span className='fs-6'>{t('recitations.surahPrefix')} {getSurahName(q)}</span>
                        <br />
                        <small>{t('recitations.by')} {reciterName}</small>
                    </div>
                    <div>{q.id}</div>
                </div>

            </button>))}

            <p></p>

            <a href="https://mp3quran.net/eng/maher" className='btn btn-sm btn-light col-12' target="_blank" rel="noreferrer"><b>{t('recitations.source')}</b></a>

        </div>
    )
}
